export class Form
{
    constructor(form, overlayNode = null, inputParentClass = '.form__field')
    {
        this.form = form;

        this.inputParentClass = inputParentClass;
        this.responsData = null;
        this.overlay = overlayNode;

        if(this.overlay){
            const close = this.overlay.querySelector('.button');

            close.addEventListener('click', () => {
                this.overlay.classList.remove('form-overlay--open');
            })
        }

        this.form.addEventListener("submit", (event) => {
            event.preventDefault();
            event.stopPropagation();

            this.submitForm().then((submitData) => {
                this.responsData = submitData;
                this.form.dispatchEvent(new Event("dataSubmitted", { bubbles: true, cancelable: false }))
            });
        });
    };

    submitForm()
    {
        const formData = new FormData(this.form);

        return new Promise((resolve, reject) => {
            fetch(this.form.action, {
                method: "POST", // *GET, POST, PUT, DELETE, etc.
                headers: {
                    "X-CSRF-TOKEN" : this.form.querySelector('input[name="_token"]').value,
                    "X-Requested-With" : "XMLHttpRequest",
                    "Accept" : "application/json",
                },
                body: formData,
            }).then((response) => {
                response.json().then((data) => {
                    let errorBag = {
                        'error': data['errors']
                    };
                    if(response.status === 400){
                        errorBag = data;
                        this.handleValidationErrors(data);
                    }
                    // Catch normal error requests from laravel
                    if(response.status === 422){
                        errorBag = {
                            'error': data['errors']
                        };
                        this.handleValidationErrors(errorBag);
                    }

                    if(response.status === 200){
                        this.handleSuccess();
                    }

                    resolve({
                        status : response.status,
                        errors : errorBag,
                        data   : data
                    });
                })
            });
        });
    }

    handleSuccess()
    {
        this.clearInputValues();

        if(!this.overlay) return;

        this.overlay.classList.add('form-overlay--open');
    }

    clearInputValues()
    {
        const inputs = Array.from(this.form.querySelectorAll('input, textarea'));

        const ignoreInputs = ['_token', '_method']

        inputs.forEach((input) => {
            if(ignoreInputs.indexOf(input.name) > -1){
                return;
            }
            input.value = "";
        })
    }

    writeMessageToInputField(name, message, isError = true, messageClass = 'form__message')
    {
        const input = this.form.querySelector('[name="'+ name +'"]');

        if(!input){
            return;
        }

        const formField = input.closest(this.inputParentClass);
        const msgNode   = document.createElement('div');
        msgNode.classList.add('form__message');
        msgNode.innerText = message;

        formField.append(msgNode);

        if(isError){
            formField.classList.add('form__field--errors');
        }
    }

    handleValidationErrors(responseData)
    {
        Object.keys(responseData['error']).forEach((key) => {
            this.writeMessageToInputField(key, responseData['error'][key])
        });
    }
}
